import { render, staticRenderFns } from "./resetTask.vue?vue&type=template&id=19a98ce7&"
import script from "./resetTask.vue?vue&type=script&lang=js&"
export * from "./resetTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports